import { BadgeCheck } from "lucide-react";
import { classNames } from "../../utils/appUtils";
import { UserView } from "../UserView";
import { Badge } from "../catalyst/badge";

interface DraftSelectPlayerProps {
  player: any;
  index: number;
  onMembersSelected: (member: any, role: string) => void;
  disabled: boolean;
}

export const DraftSelectPlayer: React.FC<DraftSelectPlayerProps> = ({
  player,
  index,
  onMembersSelected,
  disabled,
}) => {
  return (
    <div key={`player-container-${player.id}`}>
      <div
        className={classNames(
          "flex items-center justify-between p-1 rounded mb-2 gap-2",
          index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : "",
          "hidden sm:flex"
        )}
      >
        <UserView member={player} noTitle={true} />

        {player.isOwner && (
          <Badge
            color="blue"
            className="text-xs font-semibold mr-2 px-2.5 py-0.5"
          >
            Owner
          </Badge>
        )}
        <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {player.category}
        </div>
        <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {player.playerHandicap}
        </div>
        {player.isHandicapVerified && (
          <BadgeCheck className="h-5 w-5 text-green-500" />
        )}
        <button
          className="px-3 py-1 bg-blue-500 text-white rounded disabled:opacity-20"
          onClick={() => onMembersSelected(player, "coreMember")}
          disabled={disabled}
        >
          Select
        </button>
      </div>

      <div
        className={classNames(
          "flex items-center justify-between p-1 rounded mb-2",
          index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : "",
          "sm:hidden"
        )}
      >
        <div className="w-full">
          <UserView member={player} />
          <div className="flex flex-row justify-between gap-3">
            <div className="flex  gap-3">
              {player.isOwner && (
                <Badge
                  color="blue"
                  className="text-xs font-semibold mr-2 px-2.5 py-0.5"
                >
                  Owner
                </Badge>
              )}
              <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {player.category}
              </div>
              <div className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {player.playerHandicap}
              </div>
              {player.isHandicapVerified && (
                <BadgeCheck className="h-5 w-5 text-green-500" />
              )}
            </div>
            <button
              className="px-3 py-1 bg-blue-500 text-white rounded disabled:opacity-20"
              onClick={() => onMembersSelected(player, "coreMember")}
              disabled={disabled}
            >
              Pick
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
